<template>
  <div class="Content-Editor" @mousedown.self="toCloseEditor" ref="mainWrapper">
    <div class="Content-Editor__wrapper Anim__dropdown-wrapper">
      <div class="Content-Editor__wrapper-fields">
        <!-- ---------------------HEADER -------------------------------------->
        <div class="Content-Editor__hdr">
          <TypographyTitle :level="'h3'">{{ get_ttlText }}</TypographyTitle>
          <ButtonClose @click="toCloseEditor"/>
        </div>
        <!--Поле Title-->
        <div class="Content-Editor__ttl-input">
          <TextInput
            class="Form-Feedback__item"
            :placeholder="'Заголовок'"
            :type="'input'"
            :name="'title'"
            :errorMessage="titleError"
            v-model="title"
            :maxSybmols="140"
            :isCounterBottom="true"
          />
        </div>
        <!--Поле Description-->
        <div class="Content-Editor__ttl-input">
          <div class="Content-Editor__ttl-input">
            <TextInput
              class="Form-Feedback__item"
              :placeholder="'Краткое описание'"
              :type="'textarea'"
              :name="'short_description'"
              :errorMessage="shortDescriptionError"
              v-model="shortDescription"
              :maxSybmols="140"
              :isCounterBottom="true"
            />
          </div>
        </div>
        <!-- ---------------------EDITOR -------------------------------------->
        <div class="Content-Editor__editor-wrapper" :class="get_editorWrapperModify">
          <!-- text editor -->
          <div class="Content-Editor__scroll-zone" :class="get_scrollModify" v-if="editor">
            <div class="Content-Editor__loader-field" v-if="isLoadingInit">
              <LoaderCircle :color="'var(--blue-600)'" :size="32"/>
            </div>
            <EditorContent class="Content-Editor-Field" :class="get_classesModify" :editor="editor" ref="editorField" v-else/>
          </div>
          <div class="Content-Editor__interface-group">
            <!-- embed -->
            <ul class="Content-Editor__embed-list" v-if="get_isShowEmbedList">
              <li class="Content-Editor__embed-item" v-for="(embed, index) in embedList">
                <span class="Content-Editor__embed-item-txt">{{ embed }}</span>
                <CrossIcon class="Content-Editor__embed-cross" @click="removeEmbedToList(index)"/>
              </li>
            </ul>
            <!-- images -->
            <ul class="Content-Editor__images-list" v-if="oldImagesUrls">
              <li class="Content-Editor__image-item" v-for="(image, index) in oldImagesUrls" :key="index">
                <img class="Content-Editor__image" :src="image"/>
                <div class="Content-Editor__delete-img" @click="deleteOldImage(index)">
                  <CrossIcon/>
                </div>
              </li>
            </ul>
            <ul class="Content-Editor__images-list" v-if="uploadedImagesUrls">
              <li class="Content-Editor__image-item" v-for="(image, index) in uploadedImagesUrls" :key="index">
                <img class="Content-Editor__image" :src="image"/>
                <div class="Content-Editor__delete-img" @click="deleteImage(index)">
                  <CrossIcon/>
                </div>
              </li>
            </ul>
            <!-- footer -->
            <ul class="Content-Editor__editor-ftr">
              <li class="Content-Editor__editor-ftr-item">
                <EditorSmilesModule
                  class="Content-Editor__smile-module"
                  @open="toToggleSmileModule(true)"
                  @close="toToggleSmileModule(false)"
                  @smile="handleSmile"
                  @clickTrigger="handleClickTrigger"
                />
              </li>
              <li class="Content-Editor__editor-ftr-item" @click="imageInput()">
                <AddImageIcon class="Content-Editor__img-icon"/>
                <input name="images" type="file" ref="fileInput" @change="handleFileUpload($event)" accept="image/*" multiple style="display: none"/>
              </li>
              <li class="Content-Editor__editor-ftr-item" @click="makeBold">
                <BoldIcon class="Content-Editor__bold-icon"/>
              </li>
              <li class="Content-Editor__editor-ftr-item" @click="makeItalic">
                <ItalicIcon class="Content-Editor__italic-icon"/>
              </li>
              <li class="Content-Editor__editor-ftr-item" @click="toggleEmbed">
                <EmbedIcon class="Content-Editor__embed-icon"/>
              </li>
            </ul>
          </div>
        </div>
        <!-- ---------------------EMBED MODULE -------------------------------------->
        <div class="Content-Editor__embed-module" v-if="isEmbedOpen">
          <div class="Content-Editor__embed-editor" :class="get_errorEmbedClass">
            <input class="Content-Editor__embed-input" v-model="embedField" ref="embedInput" placeholder="Ссылка на Telegram или YouTube">
            <button class="Content-Editor__embed-btn" @click="addEmbedLinkToList" :class="get_disabledEmbedBtnClass">Добавить</button>
          </div>
          <p class="Content-Editor__embed-error" v-if="embedFieldError">Ссылка должна иметь формат Embed из YouTube или Telegram</p>
        </div>
        <!-- ---------------------HINT TEXT -------------------------------------->
        <BlockHintAddTicker class="Content-Editor__info"/>
      </div>
      <!-- ---------------------BUTTON -------------------------------------->
      <ButtonMain
        class="Content-Editor__btn"
        @click="toStartCreateOpinion"
        :width="'100%'"
        :loading="isLoading"
        :disabled="get_isFieldEmpty"
      >
        {{ get_btnText }}
      </ButtonMain>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, onUnmounted, nextTick} from 'vue';
import {useStore} from 'vuex';
import {EditorContent, Editor} from '@tiptap/vue-3';
import {sendNewOpinion} from './api/sendNewOpinion';
import {editOpinion} from './api/editOpinion';
import {getPostData} from '@shared/api/posts/getPostData';
import {loadImageToServer} from '@shared/api/images/loadImageToServer.js';
import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';
//-------------------------------------------
import CrossIcon from '@svg/CrossIcon.vue';
import AddImageIcon from '@svg/AddImageIcon.vue';
import InfoIcon from '@svg/InfoIcon.vue';
import BoldIcon from '@svg/BoldIcon.vue';
import ItalicIcon from '@svg/ItalicIcon.vue';
import EmbedIcon from '@svg/EmbedIcon.vue';
import ButtonMain from '@ui/Buttons/ButtonMain/ButtonMain.vue';
import ButtonClose from '@ui/Buttons/ButtonClose/ButtonClose.vue';
import TypographyTitle from '@ui/Typography/TypographyTitle/TypographyTitle.vue';
import EditorSmilesModule from '@entities/Editor/EditorSmilesModule/EditorSmilesModule.vue';
import LoaderCircle from '@shared/UI/Loaders/LoaderCircle/LoaderCircle.vue';
import BlockHintAddTicker from '@ui/Blocks/BlockHintAddTicker/BlockHintAddTicker.vue';
import TextInput from '@shared/UI/Fields/TextInput/TextInput.vue';
//-------------------------------------------
const store = useStore();
//-------------------------------------------
const YOUTUBE_REGEX = /^(https?:\/\/)?(www\.)?(youtube\.com\/embed\/|youtu\.be\/)/;
const YOUTUBE_EMBED_REGEX = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
const TELEGRAM_REGEX = /^(https?:\/\/)?(t\.me\/)/;
//-------------------------------------------
const title = ref('');
const titleError = ref('');
const shortDescription = ref('');
const shortDescriptionError = ref('');
const isLoadingInit = ref(false);
const editor = ref(null);
const editorField = ref(null);
const fileInput = ref(null);
const isEditorFocused = ref(false);
const isLoading = ref(false);
const uploadedImagesUrls = ref([]);
const uploadedImagesObjects = ref([]);
const oldImagesUrls = ref([]);
const isSmileModuleOpen = ref(false);
const embedInput = ref(null);
const embedField = ref('');
const embedFieldError = ref(false);
const embedList = ref([]);
const isEmbedOpen = ref(false);
const mainWrapper = ref(null);
//-------------------------------------------
let saveTimeout = null;
//-------------------------------------------
onMounted(async () => {
  initEditor();
  if (get_isEditMode.value) {
    await initData();
    await nextTick();
    initEmbed();
    initOldImages();
    setTimeout(() => toMoveCaretToTheEndText(), 100);
  } else {
    getTextFromLocalStorageForInit();
  }

  document.addEventListener('paste', handlePaste);
  document.addEventListener('drop', handleDrop);
});
onUnmounted(() => {
  toSaveTextToLocalStorage();
  toToggleSmileModule(false);
  setTimeout(() => {
    if (editor.value) editor.value.destroy();
    toDisableEditMode();
  }, 300);

  document.removeEventListener('paste', handlePaste);
  document.removeEventListener('drop', handleDrop);
});
//-------------------------------------------
//Определить классы модификаторы для формы
const get_classesModify = computed(() => `
    ${isEditorFocused.value ? 'Content-Editor-Field--no-placeholder' : ''}
  `);
//Определить классы модификаторы для всего попапа
const get_editorWrapperModify = computed(() => `
    ${isSmileModuleOpen.value ? 'Content-Editor__editor-wrapper--long' : ''}
  `);
//Определить классы модификаторы для области скролла контента
const get_scrollModify = computed(() => `
    ${isSmileModuleOpen.value ? 'Content-Editor__scroll-zone--short' : ''}
  `);
//Редактор открыт в режиме редактирования?
const get_isEditMode = computed(() => store.state.ContentSystem.Alpha.isEditMode);
//Получить ID редактируемого поста
const get_idEditPost = computed(() => store.state.ContentSystem.Alpha.editPostId);
//Получить редактируемый пост
const get_post = computed(() => store.state.ContentSystem.Alpha.list[get_idEditPost.value]);
//Получить текст для кнопки
const get_btnText = computed(() => get_isEditMode.value ? 'Сохранить изменения' : 'Добавить');
//Получить текст заголовка
const get_ttlText = computed(() => get_isEditMode.value ? 'Редактирование' : 'Добавить мнение');
//Поле ввода текста пустое
const get_isFieldEmpty = computed(() => !editor.value || !editor.value.getText().trim());
//Отображать ли список ссылок на внешние ресурсы
const get_isShowEmbedList = computed(() => embedList.value.length > 0);
//Применить класс модификатор в случае ошибки в поле embed
const get_errorEmbedClass = computed(() => embedFieldError.value ? 'Content-Editor__embed-editor--error' : '');
//Применить класс блокирующий кнопку 'добавить' для embed ссылки
const get_disabledEmbedBtnClass = computed(() => embedField.value ? '' : 'Content-Editor__embed-btn--disabled');
//-------------------------------------------
//Инициализация редактора
const initEditor = async () => {
  editor.value = new Editor({
    extensions: [
      StarterKit,
      Placeholder.configure({
        placeholder: 'Напишите свое мнение здесь...',
      }),
    ],
    autofocus: true,
    onFocus: () => {
      toToggleFocus(true);
    },
    onBlur: () => {
      toToggleFocus(false);
    },
    onUpdate: () => {
      if (!get_isEditMode.value) {
        scheduleAutoSave();
      }
    },
  });
}
//Получить текст из локального хранилища при инициализации редактора
const getTextFromLocalStorageForInit = async () => {
  const savedText = localStorage.getItem('editorContent');
  await nextTick();
  if (!savedText) return
  editor.value.commands.setContent(savedText);
}
//Инициализируем начальный текст (редактируемый текст)
const initData = async () => {
  const post = store.state.ContentSystem.Alpha.list[get_idEditPost.value];
  const text = post.content;
  if (post.title) title.value = post.title;
  if (post.short_description) shortDescription.value = post.short_description;
  if (!text) {
    isLoadingInit.value = true;
    await initPostData();
    isLoadingInit.value = false;
  }
  editor.value.commands.setContent(text);
}
//Инициализируем embed ссылки
const initEmbed = () => {
  if (!get_post.value) return;
  if (!get_post.value.embed_links) return;
  const links = get_post.value.embed_links.map(link => Object.keys(link)[0]);
  embedList.value = (links) ? links : [];
}
//Инициализировать старые изображения
const initOldImages = () => {
  if (!get_post.value) return;
  oldImagesUrls.value = (get_post.value.images_list) ? get_post.value.images_list : [];
}
//Отметить, что на форме есть/отсутствует фокус
const toToggleFocus = (status) => isEditorFocused.value = status;
//Сделать выделенный текст жирным
const makeBold = () => editor.value.chain().focus().toggleBold().run();
//Сделать выделенный текст курсивом
const makeItalic = () => editor.value.chain().focus().toggleItalic().run();
//Отметить процесс отправки нового мнения на сервер
const toToggleLoading = (status) => isLoading.value = status;
//Запустить процесс создания/редактирования мнения
const toStartCreateOpinion = () => {
  get_isEditMode.value ? toEditOpinion() : toSendNewOpinionToServer();
}
//Редактировать мнение
const toEditOpinion = async () => {
  try {
    toToggleLoading(true);
    const data = toPrepareData();
    const result = await editOpinion(data, get_idEditPost.value);
    toChangeOpinion(result);
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.editor);
    callOverlay({ text: 'Изменения были сохранены', color: 'green', icon: 'pen' });
  } catch (error) {
    console.error(error);
    callOverlay({ text: 'Изменения не были сохранены', color: 'red', icon: 'pen' });
  } finally {
    toToggleLoading(false);
  }
}
//Отправить новое мнение на сервер
const toSendNewOpinionToServer = async () => {
  try {
    toToggleLoading(true);
    const data = toPrepareData();
    const result = await sendNewOpinion(data);
    result.embed_links = []
    embedList.value.forEach((item) => result.embed_links.push({[item]: ''}));
    toAddNewPostToAlpha(result);
    clearField();
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.editor);
    callOverlay({ text: 'Ваше мнение успешно создано', color: 'green', icon: 'alpha' });
  } catch (error) {
    console.error(error);
    callOverlay({ text: 'Мнение не было опубликовано', color: 'red', icon: 'alpha' });
  } finally {
    toToggleLoading(false);
  }
}
//Получить данные для отправки на сервер
const toPrepareData = () => {
  const formData = new FormData();
  const htmlOutput = editor.value.getHTML();
  const encodeHtml = encodeHTML(htmlOutput);
  const postTitle = title.value || toGetTitle(htmlOutput);
  const titleWithLinks = defineLinkInTitle(postTitle);
  formData.append('content', replacePhrasesWithLinks(encodeHtml));
  formData.append('title', titleWithLinks);

  if (shortDescription.value) {
    formData.append('short_description', shortDescription.value);
  }
  if (uploadedImagesObjects.value?.length > 0) {
    uploadedImagesObjects.value.forEach((file) => formData.append('images', file));
  }
  if (oldImagesUrls.value?.length > 0) {
    oldImagesUrls.value.forEach((url) => formData.append('old_images', url));
  }
  if (embedList.value.length > 0) {
    embedList.value.forEach((url) => formData.append('embed_links', url));
  }
  return formData;
}
//Очистить поле
const clearField = () => editor.value.commands.setContent('');
//Получить данные для отправки на сервер
const toAddNewPostToAlpha = (post) => {
  store.commit('ContentSystem/Alpha/toAddNewPost', post);
}
//Обновить данные поста
const toChangeOpinion = (data) => {
  store.commit('ContentSystem/Alpha/toChangePost', data);
}
//Преобразуем текст, чтобы экранировать некоторые небезопасные элементы
const encodeHTML = (text) => {
  const div = document.createElement('div');
  div.innerHTML = text;
  return div.innerHTML;
};
//Определяем, какая часть текста будет заголовком
const toGetTitle = (html) => {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = html;
  const firstElement = tempElement.querySelector('p, h1, h2, h3, h4, h5, h6, a');
  const firstBr = firstElement.querySelector('br');
  if (firstBr) {
    let nextNode = firstBr.nextSibling;
    while (nextNode) {
      nextNode.remove();
      nextNode = firstBr.nextSibling;
    }
  }
  const htmWithoutBr = firstElement.textContent.split('<br>')[0];
  const tempTextElement = document.createElement('div');
  tempTextElement.innerHTML = htmWithoutBr;
  const text = getAllTextNodes(tempTextElement);
  const maxLength = 120;
  return text.length > maxLength ? text.substring(0, maxLength) : text;
};
//Получаем строку, состоящую только из текстовых узлов
const getAllTextNodes = (selector) => {
  let textNodes = [];
  if (!selector) return '';
  Array.from(selector.childNodes).forEach(child => {
    if (child.nodeType === Node.TEXT_NODE) {
      textNodes.push(child.textContent.trim());
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      textNodes = textNodes.concat(getAllTextNodes(child));
    }
  });
  return textNodes.join('');
}
//Определяем ссылки в заголовке
const defineLinkInTitle = (titleText) => {
  const linkRegex = /(https?:\/\/[^\s]+)/gi;
  return titleText.replace(linkRegex, (match) => {
    return `<span class="rich-text-link-title">${match}</span>`;
  });
};
//Определяем ссылки внутри контентной части
const replacePhrasesWithLinks = (text) => {
  const linkRegex = /((http|ftp|https):\/\/|www\.)[\w_-]+(?:(?:\.[\w_-]+)+)([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g;
  const textWithLinks = text.replace(linkRegex, (url) => {
    const newUrl = (!url.startsWith('http://') && !url.startsWith('https://')) ? `https://${url}` : url;
    return `<a href="${newUrl}" target="_blank">${url}</a>`;
  });
  return textWithLinks;
};
//Получаем смайл
const handleSmile = async (smile) => {
  const editorInstance = editor.value;
  if (editorInstance && editorInstance.isEditable) {
    const {from} = editorInstance.state.selection;
    editorInstance.chain().focus().insertContent({type: 'text', text: smile}).run();
    await nextTick();
    editorInstance.commands.setTextSelection(from + smile.length);
  }
};
//Получить сигнал об открытии/закрытии окна со смайликами
const toToggleSmileModule = (status) => {
  isSmileModuleOpen.value = status;
}
//Обработчик для эмита клика, сохраняющий фокус
const handleClickTrigger = async () => {
  await nextTick();
  editor.value.chain().focus();
};
//Переместить каретку в конец
const toMoveCaretToTheEndText = () => {
  const doc = editor.value.state.doc;
  editor.value.commands.setTextSelection({from: doc.content.size, to: doc.content.size});
}
//Закрыть редактор
const toCloseEditor = () => store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.editor);
//Отключить режим редактирования
const toDisableEditMode = () => {
  const data = {
    is_edit_mode: false,
    object_id: null,
  }
  store.commit('ContentSystem/Alpha/toToggleEditMode', data);
}
//Вызываем проводник для выбора картинок
const imageInput = () => {
  fileInput.value.click();
}
//Получаем выбранные файлы
const handleFileUpload = (e) => {
  const files = e.target.files;
  for (const file of files) {
    if (file.type.startsWith('image/')) {
      const imageUrl = URL.createObjectURL(file);
      uploadedImagesUrls.value.push(imageUrl);
      uploadedImagesObjects.value.push(file);
    }
  }
};
//Удаление картинки из списка
const deleteImage = (index) => {
  uploadedImagesUrls.value.splice(index, 1);
  uploadedImagesObjects.value.splice(index, 1);
}
//Удалить старое изображение
const deleteOldImage = (index) => {
  oldImagesUrls.value.splice(index, 1);
}
//Добавить Embed ссылку
const addEmbedLinkToList = () => {
  if (!checkEmbedValue()) {
    embedFieldError.value = true;
    setTimeout(() => embedFieldError.value = false, 4000);
  } else {
    embedList.value.push(embedField.value);
    embedField.value = '';
  }
}
//Убрать эмбед из списка
const removeEmbedToList = (index) => {
  embedList.value.splice(index, 1);
}
//Проверить embed ссылку на корректность
const checkEmbedValue = () => {
  const q = embedField.value;
  return YOUTUBE_EMBED_REGEX.test(q) || YOUTUBE_REGEX.test(q) || TELEGRAM_REGEX.test(q);
}
//Переключить видимость поля embed
const toggleEmbed = async () => {
  isEmbedOpen.value = !isEmbedOpen.value;
  await nextTick();
  if (isEmbedOpen.value) embedInput.value.focus();
}
//Метод для сохранения текста в localStorage
const toSaveTextToLocalStorage = () => {
  if (get_isEditMode.value) return;
  if (!editor.value) return;
  const content = editor.value.getHTML();
  localStorage.setItem('editorContent', content);
};
//Автосохранение по таймеру
const scheduleAutoSave = () => {
  clearTimeout(saveTimeout);
  saveTimeout = setTimeout(() => {
    toSaveTextToLocalStorage();
  }, 2000);
};
//Инициализировать данные поста, если они отсутствуют в хранилище
const initPostData = async () => {
  const data = await getPostData(get_idEditPost.value);
  const list = store.state.ContentSystem.Alpha.list;
  data['is_ready_inner_page'] = true;
  const {last_comment, ...rest} = data;
  list[get_idEditPost.value] = {...list[get_idEditPost.value], ...rest};
};

const handlePaste = (event) => {
  const items = (event.clipboardData || event.originalEvent.clipboardData).items;
  processItems(items);
};
// Для загрузки и отображения картинки
const uploadImage = (file) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    const imageUrl = e.target.result;
    uploadedImagesUrls.value.push(imageUrl);
    uploadedImagesObjects.value.push(file);
  };
  reader.readAsDataURL(file);
};

// Обработчики добавления картинки
const handleDrop = (event) => {
  event.preventDefault();
  const items = event.dataTransfer.items;
  processItems(items);
};
const processItems = (items) => {
  for (const item of items) {
    if (item.kind === 'file' && item.type.startsWith('image/')) {
      const file = item.getAsFile();
      uploadImage(file);
    }
  }
};
</script>

<style lang="scss">
@import './styles/_conf';
</style>
